exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-level{display:inline-flex;align-items:center;justify-content:center;vertical-align:middle}.customer-level img{width:100%;height:100%}", ""]);

// exports
